function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("ellipse", {
  cx: 92.5,
  cy: 57,
  rx: 81.5,
  ry: 57,
  fill: "#67B360"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  width: 31.6497,
  height: 8.40845,
  transform: "matrix(-0.791942 -0.610597 -0.593552 0.804795 80.6587 114.325)",
  fill: "#ED3E3E"
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  width: 55,
  height: 56,
  transform: "matrix(-1 0 0 1 55 8)",
  fill: "#004122"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M55 31H10V70C10 81.0457 18.9543 90 30 90H45C50.5228 90 55 85.5228 55 80V31Z",
  fill: "#F3F3F3"
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  width: 10.2694,
  height: 1.5,
  transform: "matrix(-1 0 0 1 54.252 33.5)",
  fill: "#004122"
});

var _ref7 = /*#__PURE__*/React.createElement("rect", {
  width: 10.2694,
  height: 1.5,
  transform: "matrix(-1 0 0 1 32.2461 33.5)",
  fill: "#004122"
});

var _ref8 = /*#__PURE__*/React.createElement("rect", {
  width: 11.7365,
  height: 18,
  transform: "matrix(-1 0 0 1 52.7847 38)",
  fill: "white"
});

var _ref9 = /*#__PURE__*/React.createElement("rect", {
  width: 8.80235,
  height: 12,
  transform: "matrix(-1 0 0 1 49.8506 38)",
  fill: "#004122"
});

var _ref10 = /*#__PURE__*/React.createElement("rect", {
  width: 2.93412,
  height: 3,
  transform: "matrix(-1 0 0 1 45.4492 39.5)",
  fill: "white"
});

var _ref11 = /*#__PURE__*/React.createElement("rect", {
  width: 11.7365,
  height: 18,
  transform: "matrix(-1 0 0 1 33.7129 38)",
  fill: "white"
});

var _ref12 = /*#__PURE__*/React.createElement("rect", {
  width: 8.80235,
  height: 12,
  transform: "matrix(-1 0 0 1 30.7788 38)",
  fill: "#004122"
});

var _ref13 = /*#__PURE__*/React.createElement("rect", {
  width: 2.93412,
  height: 3,
  transform: "matrix(-1 0 0 1 26.3774 39.5)",
  fill: "white"
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  d: "M48.0766 67.375L37.3808 76.3474L26.685 67.375H48.0766Z",
  fill: "white",
  stroke: "#004122"
});

var _ref15 = /*#__PURE__*/React.createElement("rect", {
  width: 32.2753,
  height: 46.5,
  transform: "matrix(-1 0 0 1 51.3179 93.5)",
  fill: "#ED3E3E"
});

var _ref16 = /*#__PURE__*/React.createElement("rect", {
  width: 25,
  height: 19,
  transform: "matrix(-1 0 0 1 105 106)",
  fill: "#004122"
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  d: "M81.21 108.9H81.708V110.496C81.708 110.618 81.728 110.704 81.768 110.754C81.81 110.804 81.871 110.829 81.951 110.829C82.007 110.829 82.064 110.818 82.122 110.796C82.18 110.774 82.233 110.743 82.281 110.703L82.389 110.862C82.357 110.89 82.322 110.915 82.284 110.937C82.246 110.959 82.207 110.978 82.167 110.994C82.127 111.008 82.087 111.019 82.047 111.027C82.007 111.035 81.97 111.039 81.936 111.039C81.862 111.039 81.796 111.029 81.738 111.009C81.68 110.991 81.631 110.961 81.591 110.919C81.553 110.877 81.524 110.822 81.504 110.754C81.484 110.684 81.474 110.598 81.474 110.496V109.101H81.21V108.9ZM84.3858 110.811C84.3498 110.843 84.3068 110.873 84.2568 110.901C84.2088 110.929 84.1558 110.953 84.0978 110.973C84.0398 110.993 83.9788 111.008 83.9148 111.018C83.8528 111.03 83.7898 111.036 83.7258 111.036C83.6058 111.036 83.4998 111.018 83.4078 110.982C83.3158 110.944 83.2388 110.891 83.1768 110.823C83.1148 110.753 83.0678 110.67 83.0358 110.574C83.0038 110.478 82.9878 110.37 82.9878 110.25C82.9878 110.124 83.0048 110.012 83.0388 109.914C83.0748 109.816 83.1258 109.734 83.1918 109.668C83.2578 109.602 83.3378 109.552 83.4318 109.518C83.5258 109.482 83.6308 109.464 83.7468 109.464C83.8308 109.464 83.9138 109.475 83.9958 109.497C84.0778 109.519 84.1498 109.561 84.2118 109.623C84.2758 109.683 84.3248 109.767 84.3588 109.875C84.3928 109.981 84.4048 110.119 84.3948 110.289H83.2338C83.2338 110.469 83.2818 110.604 83.3778 110.694C83.4758 110.782 83.6058 110.826 83.7678 110.826C83.8218 110.826 83.8748 110.82 83.9268 110.808C83.9808 110.794 84.0318 110.778 84.0798 110.76C84.1278 110.742 84.1698 110.722 84.2058 110.7C84.2438 110.678 84.2728 110.658 84.2928 110.64L84.3858 110.811ZM83.7528 109.662C83.6868 109.662 83.6238 109.669 83.5638 109.683C83.5058 109.697 83.4538 109.721 83.4078 109.755C83.3638 109.787 83.3268 109.83 83.2968 109.884C83.2688 109.936 83.2508 110.001 83.2428 110.079H84.1758C84.1658 109.947 84.1228 109.845 84.0468 109.773C83.9728 109.699 83.8748 109.662 83.7528 109.662ZM85.6447 108.9H86.1307V110.487C86.1307 110.505 86.1317 110.528 86.1337 110.556C86.1357 110.582 86.1377 110.61 86.1397 110.64C86.1437 110.67 86.1477 110.7 86.1517 110.73C86.1557 110.758 86.1597 110.783 86.1637 110.805H86.3647V111H85.9657L85.9357 110.769H85.9237C85.8797 110.845 85.8137 110.909 85.7257 110.961C85.6397 111.011 85.5397 111.036 85.4257 111.036C85.1997 111.036 85.0327 110.973 84.9247 110.847C84.8187 110.719 84.7657 110.521 84.7657 110.253C84.7657 110.127 84.7837 110.016 84.8197 109.92C84.8557 109.822 84.9067 109.741 84.9727 109.677C85.0407 109.611 85.1217 109.561 85.2157 109.527C85.3097 109.493 85.4147 109.476 85.5307 109.476C85.5727 109.476 85.6097 109.477 85.6417 109.479C85.6757 109.481 85.7067 109.484 85.7347 109.488C85.7627 109.492 85.7887 109.498 85.8127 109.506C85.8387 109.512 85.8667 109.519 85.8967 109.527V109.101H85.6447V108.9ZM85.4647 110.835C85.5867 110.835 85.6827 110.804 85.7527 110.742C85.8227 110.678 85.8707 110.583 85.8967 110.457V109.761C85.8527 109.731 85.8027 109.709 85.7467 109.695C85.6927 109.681 85.6207 109.674 85.5307 109.674C85.3707 109.674 85.2447 109.721 85.1527 109.815C85.0607 109.907 85.0147 110.053 85.0147 110.253C85.0147 110.335 85.0217 110.412 85.0357 110.484C85.0517 110.554 85.0767 110.615 85.1107 110.667C85.1467 110.719 85.1937 110.76 85.2517 110.79C85.3097 110.82 85.3807 110.835 85.4647 110.835ZM87.0955 110.835C87.0955 110.771 87.1135 110.722 87.1495 110.688C87.1855 110.652 87.2335 110.634 87.2935 110.634C87.3575 110.634 87.4075 110.652 87.4435 110.688C87.4795 110.722 87.4975 110.771 87.4975 110.835C87.4975 110.893 87.4795 110.941 87.4435 110.979C87.4075 111.017 87.3575 111.036 87.2935 111.036C87.2335 111.036 87.1855 111.017 87.1495 110.979C87.1135 110.941 87.0955 110.893 87.0955 110.835ZM88.2883 109.5H88.6453V109.203L88.8793 109.137V109.5H89.6803V109.701H88.8793V110.409C88.8793 110.555 88.9143 110.663 88.9843 110.733C89.0563 110.803 89.1583 110.838 89.2903 110.838C89.3803 110.838 89.4583 110.821 89.5243 110.787C89.5923 110.753 89.6533 110.716 89.7073 110.676L89.7853 110.853C89.7153 110.909 89.6313 110.954 89.5333 110.988C89.4373 111.022 89.3383 111.039 89.2363 111.039C89.1563 111.039 89.0803 111.027 89.0083 111.003C88.9383 110.981 88.8763 110.946 88.8223 110.898C88.7683 110.85 88.7253 110.789 88.6933 110.715C88.6613 110.639 88.6453 110.549 88.6453 110.445V109.701H88.2883V109.5ZM91.0831 109.5H91.5091V110.523C91.5091 110.621 91.5151 110.715 91.5271 110.805H91.7281V111H91.3291L91.3201 110.745H91.3081C91.2561 110.831 91.1871 110.901 91.1011 110.955C91.0151 111.009 90.9111 111.036 90.7891 111.036C90.6971 111.036 90.6181 111.025 90.5521 111.003C90.4881 110.983 90.4351 110.947 90.3931 110.895C90.3511 110.843 90.3201 110.774 90.3001 110.688C90.2801 110.6 90.2701 110.491 90.2701 110.361V109.701H90.0691V109.5H90.5041V110.313C90.5041 110.395 90.5071 110.469 90.5131 110.535C90.5211 110.599 90.5361 110.654 90.5581 110.7C90.5801 110.744 90.6121 110.778 90.6541 110.802C90.6981 110.824 90.7561 110.835 90.8281 110.835C90.9321 110.835 91.0221 110.801 91.0981 110.733C91.1761 110.665 91.2351 110.58 91.2751 110.478V109.701H91.0831V109.5ZM91.991 111V110.799H92.396V109.701H91.991V109.5H92.552L92.6 109.695H92.615C92.683 109.633 92.759 109.58 92.843 109.536C92.927 109.492 93.027 109.47 93.143 109.47C93.211 109.47 93.265 109.483 93.305 109.509C93.347 109.535 93.379 109.573 93.401 109.623C93.425 109.673 93.441 109.734 93.449 109.806C93.457 109.876 93.461 109.956 93.461 110.046L93.251 110.049C93.251 109.921 93.238 109.827 93.212 109.767C93.188 109.707 93.143 109.677 93.077 109.677C93.015 109.677 92.959 109.686 92.909 109.704C92.859 109.722 92.815 109.744 92.777 109.77C92.741 109.796 92.71 109.822 92.684 109.848C92.658 109.874 92.639 109.896 92.627 109.914V110.799H93.203V111H91.991ZM93.8708 110.025C93.8708 110.007 93.8698 109.984 93.8678 109.956C93.8678 109.926 93.8668 109.896 93.8648 109.866C93.8628 109.834 93.8598 109.803 93.8558 109.773C93.8538 109.743 93.8508 109.717 93.8468 109.695H93.6458V109.5H94.0478L94.0748 109.743H94.0898C94.1098 109.709 94.1358 109.676 94.1678 109.644C94.2018 109.61 94.2408 109.58 94.2848 109.554C94.3288 109.526 94.3778 109.504 94.4318 109.488C94.4858 109.472 94.5428 109.464 94.6028 109.464C94.6948 109.464 94.7758 109.474 94.8458 109.494C94.9178 109.514 94.9768 109.55 95.0228 109.602C95.0708 109.652 95.1068 109.721 95.1308 109.809C95.1548 109.895 95.1668 110.005 95.1668 110.139V111H94.9328V110.184C94.9328 110.018 94.9058 109.893 94.8518 109.809C94.7978 109.725 94.6998 109.683 94.5578 109.683C94.5058 109.683 94.4548 109.694 94.4048 109.716C94.3568 109.736 94.3128 109.763 94.2728 109.797C94.2328 109.831 94.1978 109.871 94.1678 109.917C94.1378 109.961 94.1158 110.008 94.1018 110.058V111H93.8708V110.025ZM95.5586 111.405H97.0226V111.615H95.5586V111.405ZM97.3605 110.25C97.3605 110.008 97.4235 109.817 97.5495 109.677C97.6755 109.535 97.8555 109.464 98.0895 109.464C98.2155 109.464 98.3235 109.485 98.4135 109.527C98.5055 109.567 98.5815 109.622 98.6415 109.692C98.7015 109.762 98.7455 109.845 98.7735 109.941C98.8035 110.037 98.8185 110.14 98.8185 110.25C98.8185 110.37 98.8025 110.479 98.7705 110.577C98.7385 110.673 98.6915 110.755 98.6295 110.823C98.5675 110.891 98.4905 110.944 98.3985 110.982C98.3085 111.018 98.2055 111.036 98.0895 111.036C97.9655 111.036 97.8575 111.016 97.7655 110.976C97.6735 110.934 97.5975 110.878 97.5375 110.808C97.4775 110.738 97.4325 110.655 97.4025 110.559C97.3745 110.463 97.3605 110.36 97.3605 110.25ZM97.6095 110.25C97.6095 110.32 97.6175 110.39 97.6335 110.46C97.6515 110.53 97.6795 110.593 97.7175 110.649C97.7555 110.705 97.8045 110.75 97.8645 110.784C97.9265 110.818 98.0015 110.835 98.0895 110.835C98.2495 110.835 98.3695 110.786 98.4495 110.688C98.5315 110.588 98.5725 110.442 98.5725 110.25C98.5725 110.178 98.5635 110.108 98.5455 110.04C98.5295 109.97 98.5015 109.907 98.4615 109.851C98.4235 109.795 98.3735 109.75 98.3115 109.716C98.2515 109.682 98.1775 109.665 98.0895 109.665C97.9295 109.665 97.8095 109.714 97.7295 109.812C97.6495 109.91 97.6095 110.056 97.6095 110.25ZM99.2673 110.025C99.2673 110.007 99.2663 109.984 99.2643 109.956C99.2643 109.926 99.2633 109.896 99.2613 109.866C99.2593 109.834 99.2563 109.803 99.2523 109.773C99.2503 109.743 99.2473 109.717 99.2433 109.695H99.0423V109.5H99.4443L99.4713 109.743H99.4863C99.5063 109.709 99.5323 109.676 99.5643 109.644C99.5983 109.61 99.6373 109.58 99.6813 109.554C99.7253 109.526 99.7743 109.504 99.8283 109.488C99.8823 109.472 99.9393 109.464 99.9993 109.464C100.091 109.464 100.172 109.474 100.242 109.494C100.314 109.514 100.373 109.55 100.419 109.602C100.467 109.652 100.503 109.721 100.527 109.809C100.551 109.895 100.563 110.005 100.563 110.139V111H100.329V110.184C100.329 110.018 100.302 109.893 100.248 109.809C100.194 109.725 100.096 109.683 99.9543 109.683C99.9023 109.683 99.8513 109.694 99.8013 109.716C99.7533 109.736 99.7093 109.763 99.6693 109.797C99.6293 109.831 99.5943 109.871 99.5643 109.917C99.5343 109.961 99.5123 110.008 99.4983 110.058V111H99.2673V110.025ZM102.275 111.66C102.099 111.64 101.939 111.596 101.795 111.528C101.653 111.462 101.532 111.371 101.432 111.255C101.332 111.141 101.254 111.002 101.198 110.838C101.144 110.674 101.117 110.485 101.117 110.271C101.117 110.061 101.144 109.874 101.198 109.71C101.252 109.544 101.328 109.403 101.426 109.287C101.526 109.169 101.645 109.075 101.783 109.005C101.923 108.935 102.077 108.888 102.245 108.864L102.278 109.059C102.128 109.091 101.996 109.136 101.882 109.194C101.768 109.252 101.672 109.329 101.594 109.425C101.516 109.521 101.457 109.638 101.417 109.776C101.377 109.914 101.357 110.079 101.357 110.271C101.357 110.465 101.381 110.633 101.429 110.775C101.479 110.915 101.547 111.033 101.633 111.129C101.719 111.225 101.82 111.299 101.936 111.351C102.054 111.405 102.181 111.441 102.317 111.459L102.275 111.66ZM102.958 108.864C103.134 108.884 103.293 108.928 103.435 108.996C103.579 109.062 103.701 109.153 103.801 109.269C103.901 109.385 103.978 109.525 104.032 109.689C104.088 109.853 104.116 110.041 104.116 110.253C104.116 110.463 104.088 110.651 104.032 110.817C103.978 110.981 103.901 111.121 103.801 111.237C103.703 111.355 103.585 111.449 103.447 111.519C103.309 111.589 103.156 111.636 102.988 111.66L102.955 111.465C103.105 111.433 103.237 111.388 103.351 111.33C103.465 111.272 103.561 111.195 103.639 111.099C103.717 111.003 103.776 110.886 103.816 110.748C103.856 110.61 103.876 110.445 103.876 110.253C103.876 110.059 103.851 109.892 103.801 109.752C103.753 109.61 103.686 109.491 103.6 109.395C103.514 109.299 103.412 109.225 103.294 109.173C103.178 109.119 103.052 109.083 102.916 109.065L102.958 108.864Z",
  fill: "#ED3E3E"
});

var _ref18 = /*#__PURE__*/React.createElement("rect", {
  x: 110,
  y: 131,
  width: 22,
  height: 14,
  fill: "#ED3E3E"
});

var _ref19 = /*#__PURE__*/React.createElement("rect", {
  x: 115,
  y: 136,
  width: 4,
  height: 2,
  fill: "#004122"
});

var _ref20 = /*#__PURE__*/React.createElement("rect", {
  x: 120,
  y: 141,
  width: 4,
  height: 2,
  fill: "#004122"
});

var _ref21 = /*#__PURE__*/React.createElement("rect", {
  x: 126,
  y: 134,
  width: 3,
  height: 2,
  fill: "#F3F3F3"
});

var _ref22 = /*#__PURE__*/React.createElement("rect", {
  x: 116,
  y: 139,
  width: 3,
  height: 2,
  fill: "#F3F3F3"
});

var _ref23 = /*#__PURE__*/React.createElement("rect", {
  width: 31.6497,
  height: 8.40845,
  transform: "matrix(-0.791942 -0.610597 -0.593552 0.804795 70.3892 130.825)",
  fill: "#ED3E3E"
});

var _ref24 = /*#__PURE__*/React.createElement("rect", {
  width: 31.4682,
  height: 8.29792,
  transform: "matrix(0.799879 -0.600161 0.604004 0.796982 112 112.909)",
  fill: "#004122"
});

var _ref25 = /*#__PURE__*/React.createElement("rect", {
  x: 127,
  y: 9,
  width: 72,
  height: 67,
  fill: "#004122"
});

var _ref26 = /*#__PURE__*/React.createElement("path", {
  d: "M138 38H183V71C183 80.9411 174.941 89 165 89V89C150.088 89 138 76.9117 138 62V38Z",
  fill: "#F3F3F3"
});

var _ref27 = /*#__PURE__*/React.createElement("rect", {
  x: 142,
  y: 38.3182,
  width: 9.7781,
  height: 13.6818,
  fill: "white"
});

var _ref28 = /*#__PURE__*/React.createElement("rect", {
  x: 144.444,
  y: 38.3182,
  width: 7.33357,
  height: 9.12121,
  fill: "#004122"
});

var _ref29 = /*#__PURE__*/React.createElement("rect", {
  x: 148.111,
  y: 39.4583,
  width: 2.44452,
  height: 2.2803,
  fill: "white"
});

var _ref30 = /*#__PURE__*/React.createElement("rect", {
  x: 161,
  y: 38.3182,
  width: 9.93048,
  height: 13.6818,
  fill: "white"
});

var _ref31 = /*#__PURE__*/React.createElement("rect", {
  x: 163.482,
  y: 38.3182,
  width: 7.44786,
  height: 9.12121,
  fill: "#004122"
});

var _ref32 = /*#__PURE__*/React.createElement("rect", {
  x: 167.207,
  y: 39.4583,
  width: 2.48262,
  height: 2.2803,
  fill: "white"
});

var _ref33 = /*#__PURE__*/React.createElement("path", {
  d: "M144.295 66.75L155 75.3584L165.705 66.75H144.295Z",
  fill: "white",
  stroke: "#004122"
});

var _ref34 = /*#__PURE__*/React.createElement("rect", {
  x: 141,
  y: 93,
  width: 33,
  height: 45,
  fill: "#004122"
});

var _ref35 = /*#__PURE__*/React.createElement("rect", {
  width: 31.4682,
  height: 8.29792,
  transform: "matrix(0.799879 -0.600161 0.604004 0.796982 122.313 129.034)",
  fill: "#004122"
});

var _ref36 = /*#__PURE__*/React.createElement("path", {
  d: "M80 125.5H104L98 137.5H71.5L80 125.5Z",
  fill: "#004122"
});

function SvgKlemen5(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 199,
    height: 145,
    viewBox: "0 0 199 145",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKlemen5);
export default __webpack_public_path__ + "static/media/klemen_5.b7f5d76d.svg";
export { ForwardRef as ReactComponent };